import { useState } from 'react';

export const useStateWithReset = initState => {
  const [state, setState] = useState(initState);

  const resetState = () => setState(initState);

  return [state, setState, resetState];
};